<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Employee
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Training
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/training/index">Trainers</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Update Trainer
      </h6>

      <div class="container-fluid">
        <div class="card bdr-rad2 shadow p-2" v-if="isLoading">
          <div class="card-body">
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="card bdr-rad2 shadow p-2">
          <div class="card-body">
            <form @submit.prevent="saveTrainer">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="custom-label">Trainer ID</label>
                  <input v-model="trainer.tt_trainer_id" type="number" class="form-control" required />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="custom-label">Trainer Name</label>
                  <input v-model="trainer.tt_trainer_name" type="text" class="form-control" required />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="custom-label">Designation</label>
                  <input v-model="trainer.designation" type="text" class="form-control" required />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="custom-label">Contact No</label>
                  <input v-model="trainer.contact_no" type="text" class="form-control" required />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="custom-label">Email</label>
                  <input v-model="trainer.email" type="email" class="form-control" required />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="custom-label">Department</label>
                  <select v-model="trainer.department_id" class="form-select" required>
                    <option value="" disabled>Select department</option>
                    <option v-for="dept in departments" :key="dept.value" :value="dept.value">
                      {{ dept.label }}
                    </option>
                  </select>
                </div>
                <div class="col-md-12 mb-3">
                  <label class="custom-label">Other Qualification Remarks</label>
                  <textarea v-model="trainer.other_qualififcation_remarks" class="form-control" rows="3"></textarea>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="custom-label">Status</label>
                  <select v-model="trainer.tt_status" class="form-select" required>
                    <option :value="1">Active</option>
                    <option :value="0">Inactive</option>
                  </select>
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <button type="submit" class="btn btn-sm btn-outline-primary bdr-rad">Save</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      trainer: {
        tt_trainer_id: '',
        tt_trainer_name: '',
        designation: '',
        contact_no: '',
        email: '',
        department_id: '',
        other_qualififcation_remarks: '',
        tt_status: 1,
      },
      departments: [],
      isLoading: true,
    };
  },
  mounted() {
    this.loadTrainer();
  },
  methods: {
    async loadTrainer() {
      try {
        const { data } = await axios.get('/training/loadupdate?id=' + this.$route.query.id, {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-Type': 'application/json',
          },
        });
        this.trainer = data.all_data || this.trainer;
        this.departments = data.departments || [];
      } catch (error) {
        console.log(error.response || error);
      } finally {
        this.isLoading = false;
      }
    },
    async saveTrainer() {
      try {
        const payload = {
          id: this.$route.query.id,
          all_data: {
            tt_trainer_id: this.trainer.tt_trainer_id,
            tt_trainer_name: this.trainer.tt_trainer_name,
            designation: this.trainer.designation,
            contact_no: this.trainer.contact_no,
            email: this.trainer.email,
            department_id: this.trainer.department_id,
            other_qualififcation_remarks: this.trainer.other_qualififcation_remarks,
            tt_status: this.trainer.tt_status,
          },
        };

        const { data } = await axios.post('/training/update', payload, {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-Type': 'application/json',
          },
        });

        if (data && data.status === 200) {
          this.$router.push('/training/view?id=' + this.$route.query.id);
        }
      } catch (error) {
        console.log(error.response || error);
      }
    },
  },
};
</script>

<style scoped>
.bdr-rad {
  border-radius: 12px;
}

.bdr-rad2 {
  border-radius: 15px;
}

.decoration {
  text-decoration: none;
  color: white !important;
}

.font1 {
  font-size: 13px !important;
}

.manage-boder {
  border-bottom: 2px solid #007bff;
  border-top: 2px solid #007bff;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}
</style>
